<template>
  <div>
    <q-btn
      icon="fa fa-filter"
      label="Filter Posts"
      v-bind="$attrs"
      @click="openModal"
    />
    <posts-toolbar-modal
      :filters="filters"
      @update:filters="$emit('update:filters', $event)"
      ref="modal"
    >
      <slot />
    </posts-toolbar-modal>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PostFilters, Modal as ModalElement } from '@/type';
import PostsToolbarModal from './PostsToolbarModal.vue';

export default defineComponent({
  emits: ['update:filters'],
  components: {
    PostsToolbarModal,
  },
  props: {
    filters: {
      type: Object as () => PostFilters,
      required: true,
    },
  },
  methods: {
    openModal() {
      (this.$refs.modal as ModalElement).show();
    },
  },
});
</script>
